/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AdminGetChastiaSensorConsumptionChartPathParameters } from 'api/actions/admin-get-chastia-sensor-consumption-chart/admin-get-chastia-sensor-consumption-chart-path-parameters';
import { AdminGetChastiaSensorConsumptionChartResponse } from 'api/actions/admin-get-chastia-sensor-consumption-chart/admin-get-chastia-sensor-consumption-chart-response';

type AdminGetChastiaSensorConsumptionChartQueryParameters = Record<string, any>;

/**
 * The path of the AdminGetChastiaSensorConsumptionChart action.
 */
export const adminGetChastiaSensorConsumptionChartActionPath = new SweetPath<
  keyof AdminGetChastiaSensorConsumptionChartPathParameters
>('/admin/custom/chastia-sensor-consumption-chart/{sensorId}', { path: '{param}' });

/**
 * Creates a contextualized AdminGetChastiaSensorConsumptionChart actions.
 */
export default function createAdminGetChastiaSensorConsumptionChartAction(axios: AxiosInstance) {
  return function adminGetChastiaSensorConsumptionChartAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: AdminGetChastiaSensorConsumptionChartPathParameters;
    query?: AdminGetChastiaSensorConsumptionChartQueryParameters;
  }) {
    const path = adminGetChastiaSensorConsumptionChartActionPath.insert(parameters);

    return axios.get<AdminGetChastiaSensorConsumptionChartResponse, AdminGetChastiaSensorConsumptionChartResponse>(
      path,
      { params: query, headers }
    );
  };
}
